import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  width: 85%;
  margin: auto;
  height: 21px;
  margin-bottom: 45px;
  background: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 10px;
  overflow: hidden;

  div {
    position: absolute;
    left: 0;
    background-color: #5FBADE;
    transition: width 1s;
    width: 50%;
    height: 100%;
  }

  p {
    z-index: 1;
    margin: 0 !important;
    @media (max-width: 600px) {
      font-size: 14px;
    }
  }
`

const ProgressBar = (props: { step: number }) => {
  
  const { step } = props
  
  const percentageVals = {
    1: 0,
    2: 20,
    3: 33,
    4: 40,
    5: 60,
    6: 80,
    7: 100,
    8: 0,
    10: 33,
    11: 40,
    12: 60,
    13: 80,
    19: 50,
    15: 66,
    16: 100
  }
  
  const percentage = percentageVals[step as keyof typeof percentageVals]
  
  return (
    <Wrapper>
      <div style={{ width: `${percentage}%` }} />
      <p>{percentage}%</p>
    </Wrapper>
  )
}

export default ProgressBar
